module.exports = __webpack_public_path__ + "img/2016_alloottees_bacolod.14a82f4e.jpg";